import { Box, Switch, Grid, InputLabel, Button, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import { getPointsConfig, addPointsConfig } from "../../api/pointsConfig";

export const PuntosSettings = () => {
  const [categoriesPointsConfig, setCategoriesPointsConfig] = useState([]);

  useEffect(() => {
    obtenerDatosFirebase();
  }, []);

  const obtenerDatosFirebase = async () => {
    try {
      const data = await getPointsConfig();
      console.log("Datos config",data)
      if (data.length > 0) {
        setCategoriesPointsConfig(data);
      }
    } catch (error) {
      console.error("Error al obtener datos de Firebase:", error);
    }
  };

  const handleConfigChange = (categoryName, event) => {
    const newCategoriesPointsConfig = categoriesPointsConfig.map((item) =>
      item.category === categoryName
        ? { ...item, sumaPuntos: event.target.checked }
        : item
    );
    setCategoriesPointsConfig(newCategoriesPointsConfig);
  };

  const handleSave = async () => {
    try {
      await addPointsConfig(categoriesPointsConfig);
      console.log("Configuración guardada correctamente:", categoriesPointsConfig);
    } catch (error) {
      console.error("Error al guardar la configuración:", error);
    }
  };

  return (
    <Box>
      {/* 🔵 Configuración Basquet */}
      <Box
        sx={{
          m: 5,
          p: 3,
          borderRadius: 2,
          border: 3,
          borderColor: "primary.main",
        }}
      >
        <Typography sx={{ textAlign: "center", paddingBottom: 2 }} variant="h6">
          Configuración de suma de puntos <strong>Basquet</strong>
        </Typography>
        <Grid container spacing={2}>
          {categoriesPointsConfig
            .filter((category) => category.tipo === "basquet")
            .map((category) => (
              <Grid item md={2} xl={1} key={category.category}>
                <Box>
                  <InputLabel>{category.category}</InputLabel>
                  <Switch
                    checked={category.sumaPuntos || false}
                    onChange={(e) =>
                      handleConfigChange(category.category, e)
                    }
                  />
                </Box>
              </Grid>
            ))}
        </Grid>
        <Box
          sx={{
            mt: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Button variant="contained" color="primary" onClick={handleSave}>
            Guardar
          </Button>
        </Box>
      </Box>

      {/* 🟠 Configuración Voley */}
      <Box
        sx={{
          m: 5,
          p: 3,
          borderRadius: 2,
          border: 3,
          borderColor: "primary.main",
        }}
      >
        <Typography sx={{ textAlign: "center", paddingBottom: 2 }} variant="h6">
          Configuración de suma de puntos <strong>Voley</strong>
        </Typography>
        <Grid container spacing={2}>
          {categoriesPointsConfig
            .filter((category) => category.tipo === "voley")
            .map((category) => (
              <Grid item md={2} xl={1} key={category.category}>
                <Box>
                  <InputLabel>{category.category}</InputLabel>
                  <Switch
                    checked={category.sumaPuntos || false}
                    onChange={(e) =>
                      handleConfigChange(category.category, e)
                    }
                  />
                </Box>
              </Grid>
            ))}
        </Grid>
        <Box
          sx={{
            mt: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Button variant="contained" color="primary" onClick={handleSave}>
            Guardar
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default PuntosSettings;
